import { SHStack, SHTypography } from "@components/design-systems";
import { StarSVG } from "@components/svgs";
import { AnalysisFeatureWithUniqueDTO } from "@models/platform-analysis/entities/steps/feature";

interface SummaryFeatureIncludedContentProps {
  feature: AnalysisFeatureWithUniqueDTO;
  isLasted?: boolean;
}
export const SummaryFeatureIncludedContent = ({ feature, isLasted }: SummaryFeatureIncludedContentProps) => {
  return (
    <SHStack flexDirection={"row"} alignItems={"center"}>
      <SHTypography variant="body1" colorVariant="third">
        {feature.featureName}
      </SHTypography>
      {feature.isEssential && (
        <StarSVG
          width={"13px"}
          height={"13px"}
          style={{ marginLeft: "2px", marginBottom: "2px" }}
        />
      )}
      {!isLasted && (
        <SHTypography variant="body1" colorVariant="third" sx={{ mr: "5px" }}>
          ,
        </SHTypography>
      )}
    </SHStack>
  );
};